class SaveForLaterSection extends HTMLElement {
  constructor() {
    super();
    
    this.wishlistContentsContainer = this.querySelector('[data-wishlist-grid]');
    this.moveAllBtn = this.querySelector('[data-move-all-to-cart]');

    this.products = null;
    this.listId = null;

    this.handleAddToCartEvent = this.handleAddToCartEvent.bind(this)

    this.init()
  }
  
  init() {
    this.initTemplates()
    
    if(!window.SwymCallbacks){
      window.SwymCallbacks = []
    }

    // Bind the event listener to this so we can remove it later
    this.handleSflInited = this.handleSflInited.bind(this);
    
    // Only add the event listener if it hasn't been added yet
    if (!this._listenerAdded) {
      document.addEventListener('swym:sflInited', this.handleSflInited);
      this._listenerAdded = true;
    }
  }

  handleSflInited() {
    _swat.SaveForLater.fetch(_swat.sflLid, (response) => {
      console.log(response.items)
      _swat.sfl.listcontents = response.items;
      this.renderProducts(response.items);
      this.listId = _swat.sflLid;
    }, err => console.error(err))
  }

  disconnectedCallback() {
    if (this._listenerAdded) {
      document.removeEventListener('swym:sflInited', this.handleSflInited);
      this._listenerAdded = false;
    }
  }

  initTemplates() {
    this.productCardsMarkup = `
        {{#products}}
        <div class="wishlist-item {{itemClass}}" id="{{_id}}" data-url="{{productLink}}" data-epi="{{epi}}" data-product-id="{{empi}}" data-variant-id="{{epi}}" data-list-id="{{lid}}" data-idx="15">
          <div class="wishlist-item__inner">
            <div class="wishlist-item__image">
              <a href="{{productLink}}">
                <img src="{{iu}}" alt="{{dt}}" />
              </a>
            </div>
            <div class="wishlist-item__info">
              <div class="wishlist-item__title" role="complementary">
                <a href="{{productLink}}">{{dt}}</a>
              </div>
              <div class="wishlist-item__v-info">
                <span>{{vi}}</span>
              </div>
              <div class="wishlist-item__price">
                <span class="wishlist-item__price__old"></span>
                <span>{{cu}}{{pr}}</span>
              </div>
            </div>
            <div class="wishlist-item__add-to-cart">
              <a href="javascript:void(0)" class="btn btn--primary {{btnClass}}" href="#" data-product-id="{{empi}}" data-variant-id="{{epi}}" data-list-id="{{lid}}" data-url="{{productLink}}" data-image="{{iu}}">{{addToCartTitle}}</a>
            </div>
            <a class="wishlist-item__remove" href="#" data-product-id="{{empi}}" data-variant-id="{{epi}}" data-list-id="{{lid}}" data-url="{{productLink}}" data-iu="{{iu}}" data-pr="{{pr}}" data-variants="{{variants}}">
              <span class="wishlist-icon"></span>
            </a>
            <a class="wishlist-item__overlay" href="{{productLink}}"></a>
          </div>
        </div>
        {{/products}}
      `

    this.noItemsMarkup = `
      <div class="wishlist-grid__no-items">
        <h4><strong>Looking for something?</strong></h4>
        <p>This is where we store your shopping activity for you - from your phone, tablet or computer. Continue shopping and check back later.</p>
      </div>
    `
  }

  getVariantInfo(variants){
    try {
      let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []) , variantinfo
      if(variantKeys.length > 0){
        variantinfo = variantKeys[0]
        if(variantinfo == "Default Title"){
          variantinfo = ""
        }
      } else {
        variantinfo = ""
      }
      return variantinfo
    } catch(err){
      return variants
    }
  }

  getProductDetails(product) {
    const params = {
      epi: product.epi,
      empi: product.empi,
      du: product.du,
    }

    return new Promise((resolve, reject) => {
      window._swat.getProductDetails(
        params,
        (productJson) => {
          resolve(productJson)
        },
        (e) => {
          reject(e)
        }
      )
    });
  }


  async renderProducts(products) {
    const formattedWishlistedProducts = []
    for(let p of products) {
      p = SwymUtils.formatProductPrice(p)    // formats product price and adds currency to product Object
      p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart)
      p.variantinfo = (p.variants ? this.getVariantInfo(p.variants) : "")
      // p.addToCartTitle = p.isInCart ? 'Moved to Cart' : 'Move to Cart'
      p.addToCartTitle = 'Move to Cart';
      
      try {
        let productDetails = await this.getProductDetails(p)
        
        p.available = productDetails.available
        p.comingSoon = productDetails.tags[0].indexOf('Coming in') > 0
        if (!p.available) {
          if (p.comingSoon) {
            p.addToCartTitle = 'Coming Soon'
          } else {
            p.addToCartTitle = 'Out of Stock'
          }
        }

        p.btnClass = p.available ? 'is-available' : `is-sold-out`
        p.itemClass = p.available ? 'is-available' : `is-sold-out`
        p.productLink = `${p.du}?variant=${p.epi}`
      } catch(err) {
        // If product doesn't exist?
        p.available = false
        p.addToCartTitle = 'Unavailable'
        p.btnClass = `is-unavailable`
        p.itemClass = 'is-unavailable'
        p.du = 'javascript:void(0);'
        p.productLink = 'javascript:void(0);'
      }

      formattedWishlistedProducts.push(p)
    }

    console.log(formattedWishlistedProducts)

    this.products = formattedWishlistedProducts
    let productCardsMarkup = ``

    if (this.products.length > 0) {
      productCardsMarkup = SwymUtils.renderTemplateString(this.productCardsMarkup, {products: this.products})
      this.wishlistContentsContainer.classList.remove('no-items')
      this.wishlistContentsContainer.innerHTML = productCardsMarkup
    } else {
      productCardsMarkup = this.noItemsMarkup
      this.wishlistContentsContainer.classList.add('no-items')
      this.wishlistContentsContainer.innerHTML = productCardsMarkup
    }

    this.bindEvents();

    this.classList.remove('loading')
  }

  bindEvents(){
    const addToCartButtons = [].slice.call(this.querySelectorAll('.wishlist-item__add-to-cart a'))
    const removeFromWishlistButtons = [].slice.call(this.querySelectorAll('.wishlist-item__remove'))

    for (let btn of addToCartButtons) {
      btn.addEventListener('click', this.handleAddToCartEvent, false)
    }

    for (let btn of removeFromWishlistButtons) {
      btn.addEventListener('click', this.handleRemoveFromWishlistEvent.bind(this), false)
    }

    if (this.moveAllBtn) {
      this.moveAllBtn.addEventListener('click', this.handleMoveAll.bind(this));
    }
  }

  handleAddToCartEvent(e){
    e.preventDefault()
    const { productId, variantId, url } = e.target.dataset

    if (e.target.classList.contains('is-unavailable') || e.target.classList.contains('is-sold-out')) return

    e.target.innerHTML = "Adding..";
    const wishlistItem = e.currentTarget.closest('.wishlist-item');

    window._swat.replayAddToCart(
      {empi: productId, du: url}, variantId,
      async () => {
        e.target.innerHTML = "Moved to cart";
        // Remove Item from the list
        _swat.SaveForLater.remove(this.listId, [
          {
            epi: variantId,  // unique variant of the product per listid
            empi: productId, // product id 
            du: url // product url. 
          }
        ], (response)=>{
          console.log("Successfully removed a Product from many Lists", response);
        }, (error) => {
          console.log("Error while adding a Product to many Lists", error);
        });

        wishlistItem.remove();

        // Update Minicart
        if (location.href.indexOf('/cart') > 0) {
          if (typeof updateCartContents === 'function') {
            updateCartContents();
          }
        } else {
          if (typeof theme !== 'undefined' && typeof theme.cart !== 'undefined') {
            const cart = await theme.cart.getCart();
            if (cart) {
              document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                detail: {
                  product: cart,
                }
              }));
            }
          }
        }
      },
      (e) => {
        // console.log(e)
      }
    )
  }
  
  handleRemoveFromWishlistEvent(e){
    e.preventDefault()
    const { productId, variantId, url, listId } = e.currentTarget.dataset
    const wishlistItem = e.currentTarget.closest('.wishlist-item')
    const listItemMap = {
      epi: variantId,  // unique epi per listid
      empi: productId,
      du: url
    };
    
    window._swat.deleteFromList(listId, listItemMap, function(deletedListItem){
      // successfully deleted list item
      wishlistItem.remove();

      _swat.fetchListCtx({lid: listId}, function(listContents){
        console.log(listContents)
        // if (listContents.length == 0) {
        //   window._swat.deleteList(listId, (deletedListObj) => {
        //     // successfully deleted list
        //     location.reload()
        //   }, (xhrObject) => {
        //     // something went wrong
        //   });
        // }
      }, function(xhrObj) {
        // something went wrong
      });

    }, function(xhrObj) {
      // something went wrong
    });
  }

  handleMoveAll(e) {
    const items = [...this.querySelectorAll('.wishlist-item')];
    // Add all products to the cart.
    let formData = {
      items: []
    }
    for(let item of items) {
      formData.items.push({
        id: item.dataset.variantId,
        quantity: 1
      })
    }
     
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
    })
    .then(response => {
      // Remove all products from the wishlist
      let productsToRemove = [];
      for(let item of items) {
        const { productId, variantId, url } = item.dataset
        productsToRemove.push({
          epi: variantId,  // unique variant of the product per listid
          empi: productId, // product id 
          du: url // product url. 
        })
      }

      this.wishlistContentsContainer.classList.add('no-items')
      this.wishlistContentsContainer.innerHTML = this.noItemsMarkup;

      _swat.SaveForLater.remove(this.listId, productsToRemove, (response)=>{
        console.log("Successfully removed a Product from many Lists", response);
        if (location.href.indexOf('/cart') > 0) {
          if (typeof updateCartContents === 'function') {
            updateCartContents();
          }
        }
      }, (error) => {
        console.log("Error while adding a Product to many Lists", error);
      });

    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
}

if (!customElements.get('section-save-for-later')) {
  customElements.define('section-save-for-later', SaveForLaterSection);
}
